import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'subpage.sleep.instructorVideo.heading',
		defaultMessage: 'Meet your instructor: Chibs Okereke',
		description: 'Heading for the sleep category page instructor video',
	},
});
